import { Link } from "react-router-dom"
import Navbar from "../components/Navbar"
import Footer from "../components/Footer"
import useIsMobile from "../hooks/useIsMobile"

const li = { marginBottom: 8 }

export default function TermsOfUse() {
    const isMobile = useIsMobile()
    const h2Style = { fontSize: isMobile ? 20 : 26, fontWeight: 700, margin: "40px 0 14px", color: "#111827" }

    return (
        <div style={{ width: "100%", background: "white", fontFamily: "Inter, sans-serif", color: "#111827" }}>
            <Navbar />
            <section style={{ maxWidth: 800, margin: "0 auto", padding: isMobile ? "32px 20px 80px" : "60px 24px 120px" }}>
                <Link to="/" style={{ display: "inline-flex", alignItems: "center", gap: 6, color: "#6B7280", textDecoration: "none", fontSize: 15, fontWeight: 500, marginBottom: isMobile ? 24 : 40 }}>
                    ← Back to home
                </Link>
                <h1 style={{ fontSize: isMobile ? 36 : 52, fontWeight: 800, letterSpacing: "-0.04em", margin: "0 0 16px" }}>
                    Terms of Use
                </h1>
                <p style={{ fontSize: 15, color: "#9CA3AF", marginBottom: isMobile ? 32 : 48 }}>Last updated: May 2026</p>

                <div style={{ fontSize: isMobile ? 16 : 18, color: "#374151", lineHeight: 1.8 }}>
                    <p>Welcome to Qwiztime.</p>
                    <p>By accessing or using Qwiztime, you agree to these Terms of Use. If you do not agree, please do not use the platform.</p>

                    <h2 style={h2Style}>Purpose of the Platform</h2>
                    <p>Qwiztime provides educational quizzes, diagnostic assessments, sample evaluations, and related learning content intended for informational and educational purposes only.</p>
                    <p>Qwiztime does not guarantee:</p>
                    <ul style={{ paddingLeft: 24, marginTop: 12 }}>
                        <li style={li}>academic admission outcomes</li>
                        <li style={li}>job interview success</li>
                        <li style={li}>hiring decisions</li>
                        <li style={li}>certification results</li>
                        <li style={li}>professional qualifications</li>
                    </ul>

                    <h2 style={h2Style}>User Responsibilities</h2>
                    <p>By using Qwiztime, you agree to:</p>
                    <ul style={{ paddingLeft: 24, marginTop: 12 }}>
                        <li style={li}>provide accurate information when submitting quizzes</li>
                        <li style={li}>use the platform lawfully</li>
                        <li style={li}>avoid misuse, abuse, scraping, reverse engineering, or unauthorized copying of content</li>
                        <li style={li}>avoid interfering with platform functionality or security</li>
                    </ul>

                    <h2 style={h2Style}>Intellectual Property</h2>
                    <p>All content on Qwiztime, including:</p>
                    <ul style={{ paddingLeft: 24, marginTop: 12 }}>
                        <li style={li}>quizzes</li>
                        <li style={li}>explanations</li>
                        <li style={li}>designs</li>
                        <li style={li}>branding</li>
                        <li style={li}>logos</li>
                        <li style={li}>text</li>
                        <li style={li}>graphics</li>
                        <li style={li}>software</li>
                    </ul>
                    <p>is owned by Qwiztime or its licensors and protected by applicable intellectual property laws.</p>
                    <p>You may not reproduce, redistribute, or commercially exploit platform content without written permission.</p>

                    <h2 style={h2Style}>Free Samples and Future Paid Services</h2>
                    <p>Qwiztime may provide:</p>
                    <ul style={{ paddingLeft: 24, marginTop: 12 }}>
                        <li style={li}>free sample quizzes</li>
                        <li style={li}>future paid diagnostics</li>
                        <li style={li}>premium feedback services</li>
                    </ul>
                    <p>Features, pricing, and availability may change at any time without notice.</p>

                    <h2 style={h2Style}>No Warranty</h2>
                    <p>Qwiztime is provided "as is" and "as available."</p>
                    <p>We do not guarantee:</p>
                    <ul style={{ paddingLeft: 24, marginTop: 12 }}>
                        <li style={li}>uninterrupted availability</li>
                        <li style={li}>accuracy of all content</li>
                        <li style={li}>absence of errors</li>
                        <li style={li}>compatibility with all devices or browsers</li>
                    </ul>

                    <h2 style={h2Style}>Limitation of Liability</h2>
                    <p>To the fullest extent permitted by law, Qwiztime and its operators shall not be liable for:</p>
                    <ul style={{ paddingLeft: 24, marginTop: 12 }}>
                        <li style={li}>indirect damages</li>
                        <li style={li}>loss of data</li>
                        <li style={li}>loss of opportunities</li>
                        <li style={li}>business interruption</li>
                        <li style={li}>educational or career outcomes</li>
                        <li style={li}>reliance on quiz results</li>
                    </ul>
                    <p>Use of the platform is at your own risk.</p>

                    <h2 style={h2Style}>Third-Party Services</h2>
                    <p>Qwiztime may integrate with or link to third-party services, including:</p>
                    <ul style={{ paddingLeft: 24, marginTop: 12 }}>
                        <li style={li}>Google Forms</li>
                        <li style={li}>analytics providers</li>
                        <li style={li}>payment processors</li>
                        <li style={li}>hosting platforms</li>
                    </ul>
                    <p>We are not responsible for third-party content, policies, or service availability.</p>

                    <h2 style={h2Style}>Privacy</h2>
                    <p>Your use of Qwiztime is also governed by the <Link to="/privacy" style={{ color: "#2563EB" }}>Privacy Policy</Link>.</p>

                    <h2 style={h2Style}>Termination</h2>
                    <p>We reserve the right to suspend or terminate access to the platform for misuse, abuse, or violations of these terms.</p>

                    <h2 style={h2Style}>Changes to Terms</h2>
                    <p>We may update these Terms of Use periodically. Continued use of the platform after updates constitutes acceptance of revised terms.</p>

                    <h2 style={h2Style}>Contact</h2>
                    <p>For questions regarding these Terms of Use: <a href="mailto:listener@qwiztime.ai" style={{ color: "#2563EB", textDecoration: "none", fontWeight: 600 }}>listener@qwiztime.ai</a></p>
                </div>
            </section>
            <Footer />
        </div>
    )
}
